import React from "react";
import { InputJson } from "nq-component";
import {
  deleteObjectUseCase,
  findObjectUseCase,
  getObjectUseCase,
  upsertUseCase,
} from "../../../../usecases/object";
import withRouter from "../../../../withRouter";
import BaseFormPage from "../../../../base/BaseFormPage";
import NavBar from "../../../../components/navigation";
import InputFactory from "../../../../components/InputFactory";
import AllowanceFormPresenter from "./AllowanceFormPresenter";
import Hierarchy from "../../../../components/common/Hierarchy";
import SearchSelect from "../../../../components/searchSelect/SearchSelect";
import { v4 as uuidv4 } from "uuid";
import CheckableTag from "antd/es/tag/CheckableTag";

class AllowanceFormPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = {
      object: {},
      advanced: false,
      description: "",
      allowanceType: "",
      hierarchy: {},
      amount: 0,
      selectedTaxable: "",
      excessAmount: 0,
      employmentType: {},
      employees: [],
      isMonthlyRate: false,
      isAmount: false,
    };
    this.presenter = new AllowanceFormPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase()
    );
  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevState.object !== this.state.object) {
      if (this.state.object.reference) {
        this.setState({
          // ...this.state.object,
          allowanceType: this.state.object.AllowanceType || "",
          description: this.state.object.description || "",
          amount: this.state.object.amount || 0,
          selectedTaxable: this.state.object.taxable || "",
          excessAmount: this.state.excessAmount,
          employmentType: this.state.object.employmentType || {},
          isMonthlyRate: this.state.object.isMonthlyRate,
          isAmount: this.state.object.isAmount,
        });
      }
    }
  }
  getCollectionName() {
    return "allowance_type";
  }

  handleInputChange(field, value) {
    console.log("a", field, value);
    this.setState({ [field]: value });
  }
  onchangeAmount(amount) {
    this.setState({ amount });
  }
  handleTaxableType(selectedTaxable) {
    this.setState({ selectedTaxable });
  }
  onchangeExcess(excessAmount) {
    this.setState({ excessAmount });
  }

  onChangeObject(object) {
    this.presenter.onChangeObject(object);
  }

  handleCheckBox(field) {
    this.setState((prevState) => {
      const newState = {
        isMonthlyRate:
          field === "isMonthlyRate" ? !prevState.isMonthlyRate : false,
        isAmount: field === "isAmount" ? !prevState.isAmount : false,
      };
      this.setState({ amount: newState.isMonthlyRate ? 0 : this.state.amount });

      const updatedObject = {
        ...prevState.object,
        isMonthlyRate: newState.isMonthlyRate,
        isAmount: newState.isAmount,
      };
      this.onChangeObject(updatedObject);

      return newState;
    });
  }

  async handleFormSubmit() {
    const commonAllowanceID = uuidv4().toString();
    const { employees, isMonthlyRate, isAmount, employmentType } = this.state;

    const data = {
      reference: this.state.object.reference || commonAllowanceID,
      AllowanceType: this.state.allowanceType,
      description: this.state.description,
      amount: this.state.amount,
      taxable: this.state.selectedTaxable,
      excessAmount: this.state.excessAmount,
      employmentType: { id: this.state.employmentType },
      isMonthlyRate,
      isAmount,
      // ...this.state.hierarchy,
    };
    let response = [];

    if (this.state.object.id) {
      const update = {
        id: this.state.object.id,
        ...data,
      };

      response = await upsertUseCase().execute(
        this.getCollectionName(),
        update
      );
    } else {
      await upsertUseCase().execute(this.getCollectionName(), data);
    }

    if (response.id) {
      const query = {
        where: {
          reference: response.reference,
        },
      };
      const findAllowances = await findObjectUseCase().execute(
        "allowances",
        query
      );

      for (const allowance of findAllowances) {
        const updatedAllowanceData = {
          id: allowance.id,
          allowance: this.state.allowanceType,
          amount: this.state.amount,
          taxable: this.state.selectedTaxable,
          excessAmount: this.state.excessAmount,
          isMonthlyRate,
          isAmount,
        };

        await upsertUseCase().execute("allowances", updatedAllowanceData);
      }
    } else {
      for (const employee of employees) {
        const allowanceData = {
          empID: employee.id,
          reference: commonAllowanceID,
          allowance: this.state.allowanceType,
          amount: this.state.amount,
          taxable: this.state.selectedTaxable,
          excessAmount: this.state.excessAmount,
          isMonthlyRate,
          isAmount,
        };

        await upsertUseCase().execute("allowances", allowanceData);
      }
    }

    this.presenter.showSuccess("Data Successfully Added!");
  }

  async handleObjectChange(hierarchy) {
    const query = {
      where: {
        cluster: hierarchy.selectedplantilla,
      },
    };
    const employees = await findObjectUseCase().execute("employees", query);
    this.setState({ employees: employees });

    const data = {
      region: hierarchy.selectedregions,
      office: hierarchy.selectedoffices,
      division: hierarchy.selecteddivisions,
      section: hierarchy.selectedsections,
      unit: hierarchy.selectedunits,
      cluster: hierarchy.selectedplantilla,
    };
    // this.setObject(object);
    this.setState({ hierarchy: data });
  }

  render() {
    const { object, advanced, selectedTaxable, employees } = this.state;
    console.log("ooo", object);
    console.log("EMPLOYESSSS", employees);

    const schema = this.getSchema(this.getCollectionName());
    const label = this.getObjectId() === undefined ? "Add New" : "Update ";
    const taxableType = ["YES", "NO"];
    if (!schema) return <h1>no schema</h1>;

    const labelToStateKey = {
      "Allowance Type": "allowanceType",
      Description: "description",
      "Employment Type": "employmentType",
    };
    return (
      <>
        <div className="overflow-auto mt-5">
          <div className="h-100">
            <div className="p-3 p-lg-4">
              <h1 className="fw-bold mt-3 text-capitalize">
                {(schema.label || this.getCollectionName()) + " Details"}
              </h1>
              <div className="mt-3 bg-white shadow rounded p-3 px-lg-5 py-lg-4">
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    this.handleFormSubmit();
                  }}
                >
                  <div className="">
                    {advanced ? (
                      <InputJson
                        defaultValue={object}
                        onChange={this.onChangeObject.bind(this)}
                        rows="15"
                      />
                    ) : (
                      <>
                        {["Allowance Type", "Description"].map((item) => {
                          return (
                            <div className="p-0 mb-2" key={item}>
                              <label style={{ fontSize: "14px" }}>
                                {item} <span className="text-danger">*</span>
                              </label>
                              <InputFactory
                                type="String"
                                value={this.state[labelToStateKey[item]]}
                                placeholder={item}
                                onChange={(value) =>
                                  this.handleInputChange(
                                    labelToStateKey[item],
                                    value
                                  )
                                }
                                required={true}
                              />
                            </div>
                          );
                        })}
                        <div className="d-flex gap-2 ">
                          <label>
                            <input
                              style={{
                                accentColor: "#0038A8",
                              }}
                              object={object}
                              type="checkbox"
                              onChange={() =>
                                this.handleCheckBox("isMonthlyRate")
                              }
                              checked={this.state.isMonthlyRate}
                              name="isMonthlyRate"
                            />{" "}
                            Monthly_rate
                          </label>

                          <label>
                            <input
                              style={{
                                accentColor: "#0038A8",
                              }}
                              object={object}
                              type="checkbox"
                              onChange={() => this.handleCheckBox("isAmount")}
                              checked={this.state.isAmount}
                              name="isAmount"
                            />{" "}
                            Amount
                          </label>
                        </div>
                        {this.state.isAmount && (
                          <>
                            <label style={{ fontSize: "14px" }}>
                              Amount <span className="text-danger">*</span>
                            </label>
                            <div className="p-0 mb-2">
                              <InputFactory
                                type="Number"
                                field="amount"
                                // _type="parseNumber"
                                value={this.state.amount || ""}
                                onChange={(value) => this.onchangeAmount(value)}
                              />
                            </div>
                          </>
                        )}
                        {this.state.isAmount && (
                          <div className="p-0 mb-2">
                            <label style={{ fontSize: "14px" }}>
                              Maximum-Non Taxable{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <SearchSelect
                              required
                              value={this.state.selectedTaxable}
                              onChange={this.handleTaxableType.bind(this)}
                              options={taxableType.map((types) => ({
                                label: types,
                                value: types,
                              }))}
                            />
                          </div>
                        )}
                        {this.state.selectedTaxable === "YES" && (
                          <div className="p-0 mb-2">
                            <label style={{ fontSize: "14px" }}>
                              Excess Amount
                            </label>
                            <InputFactory
                              type="Number"
                              field="excessAmount"
                              // value={this.state.excessAmount || ""}
                              defaultValue={
                                this.state.excessAmount || object.excessAmount
                              }
                              onChange={(value) => this.onchangeExcess(value)}
                            />
                          </div>
                        )}

                        {/* <div className="p-0 mb-2">
                          <Hierarchy
                            className="col-lg-12 p-1"
                            handleObjectChange={this.handleObjectChange.bind(
                              this
                            )}
                            object={this.state.object}
                            // disabled={this.getObjectId()}
                          />
                          <label style={{ fontSize: "14px" }}>
                            Employment Type
                          </label>
                          <InputFactory
                            type="Pointer"
                            field="employmentType"
                            target="employment_type"
                            value={this.state.excessAmount || ""}
                            onChange={(value) => this.onchangeExcess(value)}
                          />
                        </div> */}

                        {["Employment Type"].map((item) => {
                          return (
                            <div className="p-0 mb-2" key={item}>
                              <label style={{ fontSize: "14px" }}>
                                {item} <span className="text-danger">*</span>
                              </label>
                              <InputFactory
                                type="Pointer"
                                field={labelToStateKey[item]}
                                target="employment_type"
                                // value={this.state[labelToStateKey[item]]}
                                defaultValue={this.state[labelToStateKey[item]]}
                                placeholder={item}
                                onChange={(value) =>
                                  this.handleInputChange(
                                    labelToStateKey[item],
                                    value
                                  )
                                }
                                required={true}
                              />
                            </div>
                          );
                        })}
                      </>
                    )}
                  </div>
                  <div className="mt-4">
                    <button
                      type="submit"
                      className="btn btn-primary fs-sm me-3"
                    >
                      <i className="bi bi-file-earmark-check me-2"></i>
                      {label}
                    </button>
                    <button
                      type="button"
                      className="btn btn-light fs-sm"
                      onClick={this.onClickBack.bind(this)}
                    >
                      GO BACK
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(AllowanceFormPage);
